import { Injectable } from '@angular/core';
import { DIMBO_CONSTANT } from '../utils/constant';

@Injectable({
  providedIn: 'root'
})
export class RootService {

  getAccessToken(): string | null {
    return localStorage.getItem(DIMBO_CONSTANT.CACHE_ACCESS_TOKEN);
  }
  setAccessToken(token: string) {
    localStorage.setItem(DIMBO_CONSTANT.CACHE_ACCESS_TOKEN, token);
  }
  getRefreshToken(): string | null {
    return localStorage.getItem(DIMBO_CONSTANT.CACHE_REFRESH_TOKEN);
  }
  setRefreshToken(token: string) {
    localStorage.setItem(DIMBO_CONSTANT.CACHE_REFRESH_TOKEN, token);
  }
  getUserId(): string | null {
    return localStorage.getItem(DIMBO_CONSTANT.CACHE_USER_ID);
  }
  setUserId(userId: string) {
    localStorage.setItem(DIMBO_CONSTANT.CACHE_USER_ID, userId);
  }
  getLastLoginDateTime(): string | null {
    return localStorage.getItem(DIMBO_CONSTANT.CACHE_LAST_LOGIN_DATE_TIME);
  }
  setLastLoginDateTime(date: string) {
    localStorage.setItem(DIMBO_CONSTANT.CACHE_LAST_LOGIN_DATE_TIME, date);
  }
  clearAll() {
    localStorage.clear();
  }
}
